import { render, staticRenderFns } from "./Calculator_result.vue?vue&type=template&id=f42cf31a&scoped=true&"
import script from "./Calculator_result.vue?vue&type=script&lang=js&"
export * from "./Calculator_result.vue?vue&type=script&lang=js&"
import style0 from "./Calculator_result.vue?vue&type=style&index=0&id=f42cf31a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42cf31a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow,VSimpleTable,VTooltip})
